/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ReportingObligationVMIEnumerableApiResponse } from '../models/ReportingObligationVMIEnumerableApiResponse';
import { request as __request } from '../core/request';

export class ReportingObligationService {

    /**
     * @returns ReportingObligationVMIEnumerableApiResponse Success
     * @throws ApiError
     */
    public static async getSummaryReportObligations(): Promise<ReportingObligationVMIEnumerableApiResponse> {
        const result = await __request({
            method: 'GET',
            path: `/api/reporting-obligations`,
        });
        return result.body;
    }

}